<template>
    <div v-if="isLoading" class="loading-overlay">
        <div class="loading-spinner">
            <div class="spinner"></div>
            <h3>Downloading...</h3>
            <div class="download-progress-text">{{ downloadProgress }}%</div>
            <div class="download-progress-bar">
                <div class="download-progress-fill" :style="{ width: downloadProgress + '%' }"></div>
            </div>
        </div>
    </div>
    <div class="formgrid grid" style="width:100%;display: flex;flex-grow: 1;flex-direction: column;">
        <template v-if="preview" v-for="file in files">
            <a v-if="!isImage(file.filename) || file.progress < 100" class="col-12 md:col-10"
                style="padding: 10px 0;color:grey;cursor:pointer" @click.prevent="downloadFile(file.filename)">{{
                    file.filename }}</a>
            <div v-else class="col-12 md:col-10">
                <Image :src="`${endpoint}/${file.filename}?t=${imageReload[file.filename] || Date.now()}`" alt="Image"
                    width="200" preview @error="handleImageError(file.filename)" />
            </div>
            <ProgressBar v-if="file.progress < 100" class="col-12 md:col-2" :value="file.progress"
                style="padding:0px" />
            <div v-if="file.progress == 100 && !disabled" class="col-12 md:col-2" style="position: relative;">
                <Button icon="pi pi-times"
                    class="p-button-rounded p-button-secondary p-button-text p-button-danger center"
                    @click="deleteFile(file)" v-tooltip="'Delete'" />
            </div>
        </template>
        <Button class="p-component p-fileupload-choose" @click="selectFile" v-if="!disabled" style="min-width: 80px;">
            <input type="file" :id="id" @change="uploadFile($event)" :accept="format" :multiple="multiple"
                style="display: none;">
            <span class="p-button-icon p-button-icon-left pi-fw pi pi-upload"></span>
            <span class="p-button-label">{{ label }}</span>
        </Button>
    </div>
</template>

<script>
export default {
    name: 'UploadFile',
    props: {
        id: String,
        label: String,
        format: String,
        multiple: String,
        object: Object,
        preview: Boolean,
        disabled: Boolean,
        files: Array,
        endpoint: String
    },
    data() {
        return {
            imageReload: {},
            isLoading: false,
            downloadProgress: 0
        }
    },
    mounted() {
    },
    methods: {
        async downloadFile(filename) {
            this.isLoading = true;
            this.downloadProgress = 0;
            try {
                const response = await this.axios.get(`${this.endpoint}/${filename}`, {
                    responseType: 'blob',
                    onDownloadProgress: (progressEvent) => {
                        if (progressEvent.total) {
                            this.downloadProgress = Math.round(progressEvent.loaded * 100 / progressEvent.total);
                        }
                    }
                });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                this.downloadProgress = 100;
            } catch (error) {
                console.error('Download failed:', error);
            } finally {
                this.isLoading = false;
            }
        },
        selectFile() {
            const input = document.getElementById(this.id);
            if (!input) return;
            input.value = null;
            input.click();
        },
        uploadFile(event) {
            const input = event?.target || document.getElementById(this.id);
            const files = input ? input.files : null;
            if (this.object) {
                this.$emit('upload', { files, object: this.object });
            }
            else {
                this.$emit('upload', files);
            }
            if (input) {
                input.value = null;
            }
        },
        deleteFile(file) {
            let props = this;
            let index = this.files.indexOf(file);
            if (file.id) {
                this.axios
                    .delete(`${props.apiEndpoint}file?id=${file.id}`)
                    .then(function (response) {
                        if (index > -1) {
                            props.files.splice(index, 1);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
            }
            else if (index > -1) {
                props.files.splice(index, 1);
            }
        },
        isImage(filename) {
            return filename.includes("jpg") || filename.includes("jpeg") || filename.includes("png") || filename.includes("gif") || filename.includes("svg")
        },
        handleImageError(filename) {
            let props = this;
            console.log("Failed to load image")
            // Retry loading after 1 second
            setTimeout(() => {
                console.log("Reload")
                props.imageReload[filename] = Date.now()
            }, 1000);
        },
    }
}
</script>

<style scoped>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.loading-spinner {
    text-align: center;
}

.spinner {
    border: 8px solid #f3f3f3;
    border-top: 8px solid #00632C;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 1s linear infinite;
    margin: 0 auto 20px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.loading-spinner h3 {
    color: #00632C;
    margin: 0;
}

.download-progress-text {
    color: #00632C;
    margin-top: 12px;
    font-weight: 600;
}

.download-progress-bar {
    width: 240px;
    height: 10px;
    background-color: #e0e0e0;
    border-radius: 999px;
    margin-top: 12px;
    overflow: hidden;
}

.download-progress-fill {
    height: 100%;
    background-color: #00632C;
    transition: width 0.2s ease;
}
</style>